export default function useCookiebot() {
	const isCookiebotVisible = ref(false);
	const isCookiebotDialogVisible = ref(false);
	const button = ref<HTMLElement | null>(null);

	onMounted(() => {
		isCookiebotVisible.value = !!document.querySelector('#CybotCookiebotDialog[data-template=slideup]');

		button.value = document.querySelector('#CybotCookiebotDialogBodyLevelButtonCustomize');
		button.value?.addEventListener('click', checkCookiebotVisibility);

		window.addEventListener('CookiebotOnLoad', checkCookiebotVisibility);
		window.addEventListener('CookiebotOnDialogDisplay', checkCookiebotVisibility);
		window.addEventListener('CookiebotOnTagsExecuted', checkCookiebotVisibility);
	});

	onBeforeUnmount(() => {
		button.value?.removeEventListener('click', checkCookiebotVisibility);
		window.removeEventListener('CookiebotOnLoad', checkCookiebotVisibility);
		window.removeEventListener('CookiebotOnDialogDisplay', checkCookiebotVisibility);
		window.removeEventListener('CookiebotOnTagsExecuted', checkCookiebotVisibility);
	});

	function checkCookiebotVisibility() {
		setTimeout(() => {
			const popup = document.querySelector('#CybotCookiebotDialog[data-template=popup]');
			const slideup = document.querySelector('#CybotCookiebotDialog[data-template=slideup]');
			isCookiebotDialogVisible.value = !!popup && window.getComputedStyle(popup).display !== 'none';
			isCookiebotVisible.value = !!slideup && window.getComputedStyle(slideup).display !== 'none';

			if (slideup) {
				button.value = document.querySelector('#CybotCookiebotDialogBodyLevelButtonCustomize');
				button.value?.addEventListener('click', checkCookiebotVisibility);
			}
		}, 200);
	}

	return {isCookiebotDialogVisible, isCookiebotVisible};
}
